module.exports = __webpack_public_path__ + "img/img40.12f825e2.svg";